import { render, staticRenderFns } from "./Trigger.vue?vue&type=template&id=4be566b7"
import script from "./Trigger.vue?vue&type=script&lang=js"
export * from "./Trigger.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports